import { FormEvent, useState } from 'react';
import { CeremonialPanelFrame, OrnateControlFrame, RibbonFrame } from '../components/CeremonialFrames';
import { ACTIVATION_CODE } from '../lib/storage';

export function ActivationPage({ onActivated }: { onActivated: () => void }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  function submit(event: FormEvent) {
    event.preventDefault();
    if (code.trim().toUpperCase() !== ACTIVATION_CODE) {
      setError('激活码不正确，请检查后重试');
      return;
    }
    onActivated();
  }

  return (
    <main className="public-page activation-page">
      <img className="public-stage-art" src="/assets/public/public-stage-reference-v2.webp" alt="" width="941" height="1672" fetchPriority="high" decoding="sync" />
      <section className="ceremonial-panel activation-panel" aria-labelledby="activation-title">
        <CeremonialPanelFrame />
        <div className="ceremonial-content">
          <h1 id="activation-title" className="sr-only">你的盖世英雄正在赴约</h1>
          <img className="public-calligraphy activation-calligraphy" src="/assets/public/titles/activation-title-v3.webp" alt="" width="800" height="173" fetchPriority="high" decoding="sync" />
          <div className="ceremonial-ribbon">
            <RibbonFrame />
            <span>输入激活码，开启你的命定关系测试</span>
          </div>
          <form onSubmit={submit} noValidate>
            <label className="sr-only" htmlFor="activation-code">激活码</label>
            <div className="activation-input-wrap">
              <input id="activation-code" value={code} onChange={(event) => { setCode(event.target.value); setError(''); }} placeholder="请输入激活码" autoCapitalize="characters" autoComplete="off" />
              <span className="input-blossom" aria-hidden="true">✿</span>
            </div>
            {error && <p className="form-error" role="alert">{error}</p>}
            <button className="ornate-primary-button" type="submit">
              <OrnateControlFrame tone="rose" />
              <span>开启测试</span>
              <i className="button-blossom" aria-hidden="true">✿</i>
            </button>
          </form>
          <p className="ceremonial-foot"><span>✿</span>激活成功后即可进入测试首页<span>✿</span></p>
        </div>
      </section>
    </main>
  );
}
